import { Injectable, NgZone } from '@angular/core';
import { ErrorDialogComponent } from '../components/error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CcmcApiService } from './ccmc-api.service';
import { Router } from '@angular/router';
import { SpinnerService } from './spinner.service';
import { ActiveLosService } from './active-los.service';
import { navigation } from '../../app/navigation/navigation';
import { SuccessDialogComponent } from '../components/success-dialog/success-dialog.component';
import { AssetService } from './asset.service';
import { catchError, filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CustomErrorHandlerService } from './custom-error-handler.service';
import { ConditionsService } from './conditions.service';
import { CaptureDataService } from './capture-data.service';
import { AmplifyService } from './amplify.service';
import { GlobalSearchService } from './global-search.service';
import { TargetResponseDialogComponent } from '../components/target-response-dialog/target-response-dialog.component';
import { DebitCeditCheckDialogComponent } from '../components/debit-cedit-check-dialog/debit-cedit-check-dialog.component';
const { Buffer } = require('buffer');

// Signature GL field patterns (* replaced with zero-padded instance)
const SIG_GL_TRNCODE_FIELD = 'MONGL_*_006';
const SIG_GL_AMOUNT_FIELD = 'MONGL_*_012';
// Signature DDA field patterns (* replaced with zero-padded instance)
const SIG_DDA_TRNCODE_FIELD = 'DDA_*_006';
const SIG_DDA_AMOUNT_FIELD = 'DDA_*_019';
@Injectable({
  providedIn: 'root'
})
export class SignatureService {
  dynamicNav: any = navigation;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(
    private dialog: MatDialog,
    private ccmcApiService: CcmcApiService,
    private router: Router,
    private spinnerService: SpinnerService,
    private activeLosService: ActiveLosService,
    private zone: NgZone,
    private assetService: AssetService,
    private amplifyService: AmplifyService,
    private http: HttpClient,
    private customErrorHandlerService: CustomErrorHandlerService,
    private conditionsService: ConditionsService,
    private captureDataService: CaptureDataService,
    private globalSearchService: GlobalSearchService
  ) {}

  /**
   * @description books the loan to the core and runs GL balance check before sending. If out of balance, prompts user for confirmation.
   */
  async send() {
    this.spinnerService.setShowSpinner(true);

    if (!await this.glBalanceCheck()) {
      this.spinnerService.setShowSpinner(false);
      return;
    }

    let userName = this.amplifyService.username;
    const exportObject = {
      content: {
        mapping: this.ccmcApiService.mapping,
        configurations: this.ccmcApiService.configurations,
        transactions: this.ccmcApiService.transactions
      },
      user: userName,
      assetID: this.assetService.getSelectedAssetId()
    };
    console.log(exportObject);
    this.export(exportObject).subscribe(async res => {
      console.log(res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      if (parsedResult.error) {
        const errorMessage = {
          statusMessage: "Ground Control failed to receive a response back from the communicator",
          statusFlag: false
        };
        const dialogRef2 = this.zone.run(() => {
          this.dialog.open(TargetResponseDialogComponent, {
            data: errorMessage
          });
        });
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: this.getLoanNumber(),
          statusMessage: parsedResult.error,
          statusFlag: false
        });
      }
      if (parsedResult.statusFlag === true) {
        let loanNumber;
        if (parsedResult.loanNumber) {
          loanNumber = parsedResult.loanNumber;
        } else {
          loanNumber = this.getLoanNumber();
        }
        const resultMessage = {
          statusMessage: parsedResult.statusMessage,
          loanNumber: loanNumber,
          statusFlag: true
        };
        this.captureDataService.uploadS3File(this.ccmcApiService.mapping);
        this.activeLosService.activeLosService.loanBooked(
          parsedResult,
          JSON.parse(JSON.stringify(this.ccmcApiService.configurations))
        );
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: loanNumber,
          statusMessage: parsedResult.statusMessage,
          statusFlag: parsedResult.statusFlag
        });
        this.ccmcApiService.mapping = undefined;
        this.ccmcApiService.coreSettings = undefined;
        this.ccmcApiService.conditions = undefined;
        this.ccmcApiService.mapping = undefined;
        this.ccmcApiService.supportValues = undefined;
        this.ccmcApiService.search = undefined;
        this.ccmcApiService.transactions = undefined;
        this.ccmcApiService.configurations = undefined;
        if (this.dynamicNav[1].children[1]) {
          this.dynamicNav[1].children[1].children = [];
        }
        this.dynamicNav[1].children[0].badge.title = undefined;
        const dialogRef = this.dialog.open(TargetResponseDialogComponent, {
          data: resultMessage
        });
        dialogRef.afterClosed().subscribe(result => {
          if (this.activeLosService.activeLos === 'encompass' || this.activeLosService.activeLos === 'bytepro') {
            this.router.navigate(['loan-lookup']);
          } else {
            this.router.navigate(['file-selector']);
          }
        });
      }
      if (parsedResult.statusFlag === false) {
        if (parsedResult.content && parsedResult.content.mapping) {
          // Retrieve Validation From existing mapping object
          let existingMappingCopy = JSON.parse(
            JSON.stringify(this.ccmcApiService.mapping)
          );
          for (let mappingItem of parsedResult.content.mapping) {
            let existingMappingIndex = existingMappingCopy.findIndex(
              (obj: any) => obj.fieldID === mappingItem.fieldID
            );
            if (
              existingMappingIndex > -1 &&
              existingMappingCopy[existingMappingIndex].validation
            ) {
              mappingItem.validation =
                existingMappingCopy[existingMappingIndex].validation;
            }
          }
          this.ccmcApiService.mapping = parsedResult.content.mapping;
        }
        if (parsedResult.content && parsedResult.content.transactions) {
          this.ccmcApiService.transactions = parsedResult.content.transactions;
        }
        this.globalSearchService.initData();
        const errorMessage = {
          statusMessage: parsedResult.statusMessage,
          statusFlag: false
        };
        const dialogRef = this.dialog.open(TargetResponseDialogComponent, {
          data: errorMessage
        });
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: this.getLoanNumber(),
          statusMessage: parsedResult.statusMessage,
          statusFlag: parsedResult.statusFlag
        });
      }
    });
  }

  /**
   * Tallies GL debits and credits across displayed transactions.
   * Uses transaction codes from host config to determine credit vs debit.
   */
  async glBalanceCheck(): Promise<boolean> {
    return new Promise((resolve) => {
      console.log('[glBalanceCheck] showGLBalancePrompt:', this.ccmcApiService.configurations.showGLBalancePrompt);
      // Skip balance check only if explicitly set to false
      if (this.ccmcApiService.configurations.showGLBalancePrompt === false) {
        return resolve(true);
      }

      const zeroPad = (num: number, places: number) => String(num).padStart(places, '0');
      let glCreditCounter = 0;
      let glDebitCounter = 0;
      let ddaCreditCounter = 0;
      let ddaDebitCounter = 0;

      // Get transaction code lists from configuration
      const glCreditCodes = (this.ccmcApiService.configurations.signatureGLCreditTranCodes || '').toUpperCase().split(',').map((c: string) => c.trim());
      const glDebitCodes = (this.ccmcApiService.configurations.signatureGLDebitTranCodes || '').toUpperCase().split(',').map((c: string) => c.trim());
      const ddaCreditCodes = (this.ccmcApiService.configurations.signatureDDACreditTranCodes || '').toUpperCase().split(',').map((c: string) => c.trim());
      const ddaDebitCodes = (this.ccmcApiService.configurations.signatureDDADebitTranCodes || '').toUpperCase().split(',').map((c: string) => c.trim());
      console.group('[glBalanceCheck]');
      console.log('GL credit codes:', glCreditCodes);
      console.log('GL debit codes:', glDebitCodes);
      console.log('DDA credit codes:', ddaCreditCodes);
      console.log('DDA debit codes:', ddaDebitCodes);
      console.groupEnd();

      // Process GL transactions (MONGL_##_*)
      let instance = 1;
      let padded = zeroPad(instance, 2);
      let trnCodeFieldId = SIG_GL_TRNCODE_FIELD.replace('*', padded);
      let trnCodeIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === trnCodeFieldId);
      let amtFieldId = SIG_GL_AMOUNT_FIELD.replace('*', padded);
      let amtIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === amtFieldId);
      console.log('[glBalanceCheck] First GL lookup:', trnCodeFieldId, 'index:', trnCodeIndex, amtFieldId, 'index:', amtIndex);

      while (trnCodeIndex > -1 && amtIndex > -1) {
        const txnId = this.ccmcApiService.mapping[trnCodeIndex].transactionID;
        const txnIndex = this.ccmcApiService.transactions.findIndex(
          (t: any) => t.transactionID === txnId
        );
        const txn = txnIndex > -1 ? this.ccmcApiService.transactions[txnIndex] : null;

        if (txn && txn.display) {
          const tranCode = this.ccmcApiService.mapping[trnCodeIndex].fieldValue.toUpperCase();
          const amount = Math.abs(+this.ccmcApiService.mapping[amtIndex].fieldValue);

          if (glCreditCodes.includes(tranCode)) {
            glCreditCounter += amount;
          } else if (glDebitCodes.includes(tranCode)) {
            glDebitCounter += amount;
          }
        }

        instance++;
        padded = zeroPad(instance, 2);
        trnCodeFieldId = SIG_GL_TRNCODE_FIELD.replace('*', padded);
        trnCodeIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === trnCodeFieldId);
        if (trnCodeIndex > -1) {
          amtFieldId = SIG_GL_AMOUNT_FIELD.replace('*', padded);
          amtIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === amtFieldId);
        }
      }
      console.log('[glBalanceCheck] After GL totals - credit:', glCreditCounter, 'debit:', glDebitCounter, 'total:', (glCreditCounter - glDebitCounter));

      // Process DDA transactions (DDA_##_*)
      instance = 1;
      padded = zeroPad(instance, 2);
      trnCodeFieldId = SIG_DDA_TRNCODE_FIELD.replace('*', padded);
      trnCodeIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === trnCodeFieldId);
      amtFieldId = SIG_DDA_AMOUNT_FIELD.replace('*', padded);
      amtIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === amtFieldId);
      console.log('[glBalanceCheck] First DDA lookup:', trnCodeFieldId, 'index:', trnCodeIndex, amtFieldId, 'index:', amtIndex);

      while (trnCodeIndex > -1 && amtIndex > -1) {
        const txnId = this.ccmcApiService.mapping[trnCodeIndex].transactionID;
        const txnIndex = this.ccmcApiService.transactions.findIndex(
          (t: any) => t.transactionID === txnId
        );
        const txn = txnIndex > -1 ? this.ccmcApiService.transactions[txnIndex] : null;

        if (txn && txn.display) {
          const tranCode = this.ccmcApiService.mapping[trnCodeIndex].fieldValue.toUpperCase();
          const amount = Math.abs(+this.ccmcApiService.mapping[amtIndex].fieldValue);

          if (ddaCreditCodes.includes(tranCode)) {
            ddaCreditCounter += amount;
          } else if (ddaDebitCodes.includes(tranCode)) {
            ddaDebitCounter += amount;
          }
        }

        instance++;
        padded = zeroPad(instance, 2);
        trnCodeFieldId = SIG_DDA_TRNCODE_FIELD.replace('*', padded);
        trnCodeIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === trnCodeFieldId);
        if (trnCodeIndex > -1) {
          amtFieldId = SIG_DDA_AMOUNT_FIELD.replace('*', padded);
          amtIndex = this.ccmcApiService.mapping.findIndex((m: any) => m.fieldID === amtFieldId);
        }
      }
      console.log('[glBalanceCheck] After DDA totals - credit:', ddaCreditCounter, 'debit:', ddaDebitCounter, 'total:', (ddaCreditCounter - ddaDebitCounter));

      const total = (glCreditCounter + ddaCreditCounter) - (glDebitCounter + ddaDebitCounter);
      console.log('[glBalanceCheck] Final totals - credit:', (glCreditCounter + ddaCreditCounter), 'debit:', (glDebitCounter + ddaDebitCounter), 'total:', total);

      // If balanced, proceed without prompting
      if (total === 0) {
        return resolve(true);
      }

      const dialogRef = this.dialog.open(DebitCeditCheckDialogComponent, {
        data: {
          message: 'Transactions are out of balance, please confirm if you would like to proceed.',
          credit: glCreditCounter,
          debit: glDebitCounter,
          ddaCredit: ddaCreditCounter,
          ddaDebit: ddaDebitCounter,
          glTotal: (glCreditCounter - glDebitCounter),
          ddaTotal: (ddaCreditCounter - ddaDebitCounter),
          total: total,
          isDDA: true
        },
        panelClass: 'dda-debit-credit__dialog'
      });

      dialogRef.afterClosed().subscribe(confirmed => {
        resolve(confirmed === true);
      });
    });
  }

  /**
   * @description
   */
  customerSearch(borrower: any, callback: any) {
    let userName = this.amplifyService.username;
    const request = {
      content: borrower,
      assetID: this.assetService.getSelectedAssetId(),
      user: userName
    };
    console.log(request);
    request.content.cognitoID = this.amplifyService.getCognitoId();
    this.searchCustomer(request).subscribe(res => {
      console.log(res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      // console.log(parsedResult.error);
      if (parsedResult.error) {
        const errorMessage = {
          message: JSON.stringify(parsedResult.error.message),
          title: 'Signature Result'
        };

        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
      if (parsedResult.statusFlag === true) {
        this.spinnerService.setShowSpinner(false);
        const payload = parsedResult.content;
        if (payload.length > 0) {
          const searchResult = payload;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        }
      } else if (parsedResult.statusFlag === false) {
        const errorMessage = {
          message: parsedResult.statusMessage,
          title: 'Search Error'
        };

        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
    });
  }

  assignBorrowers(party: any) {
    for (let i = 0; i < party.length; i++) {
      const CIFFields = party[i].CIFFields.split(',');
      CIFFields.forEach((cf: any) => {
        const cifIndex = this.ccmcApiService.mapping.findIndex(
          (f: any) => f.fieldID === cf.trim()
        );
        // console.log(cf);
        this.ccmcApiService.mapping[cifIndex].fieldValue = party[i].CIF;
      });
    }
  }

  async productInquiry() {
    return new Promise(resolve => {
      // this.spinnerService.setShowSpinner(false);
      const initializeDefaultsReq = {
        content: {
          mapping: this.ccmcApiService.mapping,
          configurations: this.ccmcApiService.configurations,
          transactions: this.ccmcApiService.transactions
        },
        assetId: this.assetService.getSelectedAssetId()
      };
      this.callProductInquiry(initializeDefaultsReq).subscribe(result => {
        console.log('product inquiry', result);
        const parsedResult = JSON.parse(JSON.stringify(result));
        if (parsedResult.statusFlag === false) {
          const errorMessage = {
            message: parsedResult.statusMessage,
            title: 'Product Inquiry Error'
          };

          const dialogRef = this.zone.run(() => {
            this.dialog.open(ErrorDialogComponent, {
              data: errorMessage
            });
          });
          resolve(true);
        } else {
          this.spinnerService.setShowSpinner(false);
          console.log(JSON.parse(parsedResult.content));
          this.ccmcApiService.mapping = JSON.parse(
            parsedResult.content
          ).mapping;
          this.conditionsService.evaluateConditions();
          resolve(true);
        }
      });
    });
  }

  callProductInquiry(params: any) {
    let userName = this.amplifyService.username;
    
    console.log(params);
    return this.http
      .post(
        `${Buffer.from(environment.environmentURL, "base64").toString()}/fiserv/signature/product-inquiry`,
        params,
        this.httpOptions
      )
      .pipe(catchError(this.customErrorHandlerService.handleError));
  }

  export(params: any) {
    
    console.log(params);
    return this.http
      .post(
        `${Buffer.from(environment.environmentURL, "base64").toString()}/fiserv/signature/export-messages`,
        params,
        this.httpOptions
      )
      .pipe(catchError(this.customErrorHandlerService.handleError));
  }

  searchCustomer(params: any) {
    
    console.log(JSON.stringify(params));
    return this.http
      .post(
        `${Buffer.from(environment.environmentURL, "base64").toString()}/fiserv/signature/search-customer`,
        params,
        this.httpOptions
      )
      .pipe(catchError(this.customErrorHandlerService.handleError));
  }

  /**
   * auto Customer Search
   * @description performs the auto customers search
   * @param {*} borrower
   * @param {*} callback
   * @memberof IBSService
   */
  autoCustomerSearch(borrower: any, callback: any) {
    let userName = this.amplifyService.username;
    const request = {
      content: borrower,
      assetID: this.assetService.getSelectedAssetId(),
      user: userName
    };
    console.log('Request: \n', JSON.stringify(request));
    request.content.cognitoID = this.amplifyService.getCognitoId();
    this.searchCustomer(request).subscribe(res => {
      console.log('Customer search response: ', res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      console.log(parsedResult);
      if (parsedResult.error) {
        const errorMessage = {
          message: JSON.stringify(parsedResult.error.message),
          title: 'Signature Result'
        };

        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
      if (parsedResult.statusFlag === true) {
        this.spinnerService.setShowSpinner(false);
        const payload = parsedResult.content;
        if (payload.length > 0) {
          const searchResult = payload;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        }
      } else if (parsedResult.statusFlag === false) {
        this.spinnerService.setShowSpinner(false);
        if (
          parsedResult.statusMessage
            .toLowerCase()
            .includes('no customer record found')
        ) {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const errorMessage = {
            message: parsedResult.statusMessage,
            title: 'Search Error'
          };

          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            data: errorMessage
          });
          callback(parsedResult);
        }
      }
    });
  }

  getLoanNumber() {
    console.log('get Loan number');
    let loanFieldIndex = this.ccmcApiService.mapping.findIndex(
      (obj: any) => obj.fieldID === 'LNBR'
    );
    if (loanFieldIndex > -1) {
      // Return loan number
      console.log(
        'loan number',
        this.ccmcApiService.mapping[loanFieldIndex].fieldValue
      );
      return this.ccmcApiService.mapping[loanFieldIndex].fieldValue;
    }
  }

  checkProductInquiry() {
    // If Signature Disable Product Inquiry is set to true we dont make the call
    if (
      this.ccmcApiService.configurations.signatureDisableProductInquiry !==
      undefined
    ) {
      if (this.ccmcApiService.configurations.signatureDisableProductInquiry) {
        return false;
      } else return true;
    } else return true;
  }
}
